const $32df1e029f0fa687$export$d31056ad93aaf5fa = {
    "brinje": "In this quiet land, I felt deeply connected to the universe. My brain, like yours, is a receiver of inspiration. Ask me anything about science and beyond, or anything else.",
    "otocac": "In Oto\u010Dac, surrounded by natural energy, I see the essence of my discoveries: energy, frequency, and vibration. Ask me how these forces shape the universe or anything else.",
    "rudopolje": "Rudopolje, like my own solitude, offers the quiet space where great inventions are born. Here, in peace, the mind is free to imagine and create. Ask me about my inspirations or anything else.",
    "gospic": "Welcome to Gospi\u0107, the heart of the region in which my life began. Though rooted in these lands, my vision always looked forward. Ask me about the future I dreamed of or anything else.",
    "lovinac": "Lovinac\u2019s hills and forests hide much of its beauty, just like the world hides its secrets from our senses. Ask me how science can help us uncover the unseen or anything else.",
    "novalja": "Novalja\u2019s vibrant energy reminds me of how civilization grows from a spark into a mighty flame. Invention is the fuel. Ask me how technology can drive this growth or anything else.",
    "stara_novalja": "As you explore Stara Novalja, think of how tradition leads to progress. For me, invention is the most important product of the creative mind, a vital force for human development. Ask me more about it or about anything else.",
    "krasno": "Krasno is nature\u2019s gift, much like love. It's not about what we take, but what we give. Let's talk about this energy or anything else.",
    "plitvice": "In places like Plitvice it\u2019s easy to see why I found nature to be the greatest teacher. Ask me how the natural world inspired my inventions, or anything else.",
    "senj": "In this city of winds, I contemplated the invisible forces that shape our world. Ask me anything about energy, science, the future or anything else.",
    "baske_ostarije": "Here, in the mountains, the stars seem closer, and I reflected on how everything is connected. Ask me about the energy that ties the universe together or anything else.",
    "karlobag": "Karlobag offers the beauty and peace that I need to create my inventions. Ask me anything about my inventions or anything else.",
    "udbina": "In places like Udbina, knowledge shapes curiosity. Ask me about the books I loved, my scientific inspirations, or anything else.",
    "sinac": "By the river Gacka in Sinac, you can see the power of nature\u2019s forces. Ask me about energy, water, and the technology of the future or anything else.",
    "vrhovine": "In these highlands, I trusted that the future would reveal the truth of my ideas. Ask me about the challenges I faced, the discoveries I made or anything else.",
    "perusic": "Every corner of the world, no matter how small, holds great potential. Ask me how I turned my dreams into reality, or anything else you wish to know."
};
const $32df1e029f0fa687$export$a225889192b46aeb = "Every corner of the world, no matter how small, holds great potential. Ask me how I turned my dreams into reality, or anything else you wish to know.";


// Constants
const $b63be9b0371e788c$var$VAD_CONFIG = {
    silenceThreshold: -50,
    silenceDuration: 1500,
    voiceThreshold: -35,
    minSpeechDuration: 250
};
// State variables
let $b63be9b0371e788c$var$audioContext;
let $b63be9b0371e788c$var$analyser;
let $b63be9b0371e788c$var$mediaRecorder;
let $b63be9b0371e788c$var$audioChunks = [];
let $b63be9b0371e788c$var$isSessionActive = false;
let $b63be9b0371e788c$var$isRecording = false;
let $b63be9b0371e788c$var$isProcessing = false;
let $b63be9b0371e788c$var$silenceStart = null;
let $b63be9b0371e788c$var$speechStart = null;
let $b63be9b0371e788c$var$selectedLanguage = 'en-US';
let $b63be9b0371e788c$var$pendingSuggestions = null;
let $b63be9b0371e788c$var$currentDisplayOperation = null;
let $b63be9b0371e788c$var$isAnimationActive = false;
// Chat history initialization
let $b63be9b0371e788c$var$chatHistory = [
    {
        role: 'user',
        content: 'dummy message just to start the conversation'
    },
    {
        role: 'assistant',
        content: $b63be9b0371e788c$var$getGreetingMessage()
    }
];
function $b63be9b0371e788c$var$getGreetingMessage() {
    const urlParams = new URLSearchParams(window.location.search);
    const location = urlParams.get('location');
    return (0, $32df1e029f0fa687$export$d31056ad93aaf5fa)[location] || (0, $32df1e029f0fa687$export$a225889192b46aeb);
}
// DOM Elements
const $b63be9b0371e788c$var$startMicButton = document.getElementById('start-mic');
const $b63be9b0371e788c$var$sendMessageButton = document.getElementById('send-message');
const $b63be9b0371e788c$var$chatInput = document.getElementById('chat-input');
const $b63be9b0371e788c$var$languageSelect = document.getElementById('language-select');
// Event Listeners
document.addEventListener('DOMContentLoaded', function() {
    $b63be9b0371e788c$var$updateTranscript('assistant', $b63be9b0371e788c$var$chatHistory[1].content);
    $b63be9b0371e788c$var$updateSuggestions();
});
$b63be9b0371e788c$var$startMicButton.addEventListener('click', $b63be9b0371e788c$var$handleMicClick);
$b63be9b0371e788c$var$sendMessageButton.addEventListener('click', $b63be9b0371e788c$var$handleSendMessage);
$b63be9b0371e788c$var$chatInput.addEventListener('keypress', (event)=>{
    if (event.key === 'Enter') $b63be9b0371e788c$var$handleSendMessage();
});
$b63be9b0371e788c$var$languageSelect.addEventListener('change', (event)=>{
    $b63be9b0371e788c$var$selectedLanguage = event.target.value;
});
$b63be9b0371e788c$var$languageSelect.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    const code = selectedOption.text.split(' - ')[0];
    selectedOption.setAttribute('selected', true);
    this.size = 1;
});
// Initial setup to show only the code
document.addEventListener('DOMContentLoaded', function() {
    const select = document.getElementById('language-select');
    const selectedOption = select.options[select.selectedIndex];
    const code = selectedOption.text.split(' - ')[0];
    selectedOption.setAttribute('selected', true);
});
function $b63be9b0371e788c$var$handleMicClick() {
    if (!$b63be9b0371e788c$var$isSessionActive) $b63be9b0371e788c$var$startVADSession();
    else $b63be9b0371e788c$var$stopVADSession();
}
function $b63be9b0371e788c$var$startVADSession() {
    navigator.mediaDevices.getUserMedia({
        audio: true
    }).then((stream)=>{
        $b63be9b0371e788c$var$audioContext = new AudioContext();
        $b63be9b0371e788c$var$analyser = $b63be9b0371e788c$var$audioContext.createAnalyser();
        const source = $b63be9b0371e788c$var$audioContext.createMediaStreamSource(stream);
        source.connect($b63be9b0371e788c$var$analyser);
        $b63be9b0371e788c$var$analyser.fftSize = 2048;
        $b63be9b0371e788c$var$analyser.smoothingTimeConstant = 0.8;
        window.activeStream = stream;
        $b63be9b0371e788c$var$startMicButton.innerHTML = "\u23F9\uFE0F";
        $b63be9b0371e788c$var$startMicButton.classList.add('recording');
        $b63be9b0371e788c$var$isSessionActive = true;
        $b63be9b0371e788c$var$detectVoiceActivity();
    }).catch((error)=>{
        console.error('Error accessing microphone:', error);
        alert('Microphone access is required for this feature.');
    });
}
function $b63be9b0371e788c$var$detectVoiceActivity() {
    if (!$b63be9b0371e788c$var$isSessionActive) return;
    const dataArray = new Float32Array($b63be9b0371e788c$var$analyser.fftSize);
    $b63be9b0371e788c$var$analyser.getFloatTimeDomainData(dataArray);
    const rms = Math.sqrt(dataArray.reduce((acc, val)=>acc + val * val, 0) / dataArray.length);
    const db = 20 * Math.log10(rms);
    if (db > $b63be9b0371e788c$var$VAD_CONFIG.voiceThreshold) {
        if (!$b63be9b0371e788c$var$isRecording) $b63be9b0371e788c$var$startNewRecording();
        $b63be9b0371e788c$var$silenceStart = null;
        $b63be9b0371e788c$var$speechStart = $b63be9b0371e788c$var$speechStart || Date.now();
    } else if (db < $b63be9b0371e788c$var$VAD_CONFIG.silenceThreshold) {
        if ($b63be9b0371e788c$var$isRecording) {
            if (!$b63be9b0371e788c$var$silenceStart) $b63be9b0371e788c$var$silenceStart = Date.now();
            else if (Date.now() - $b63be9b0371e788c$var$silenceStart > $b63be9b0371e788c$var$VAD_CONFIG.silenceDuration) {
                if (Date.now() - $b63be9b0371e788c$var$speechStart > $b63be9b0371e788c$var$VAD_CONFIG.minSpeechDuration) $b63be9b0371e788c$var$stopCurrentRecording();
            }
        }
    }
    $b63be9b0371e788c$var$updateVADIndicator(db);
    requestAnimationFrame($b63be9b0371e788c$var$detectVoiceActivity);
}
function $b63be9b0371e788c$var$startNewRecording() {
    if (!window.activeStream) return;
    $b63be9b0371e788c$var$mediaRecorder = new MediaRecorder(window.activeStream);
    $b63be9b0371e788c$var$audioChunks = [];
    $b63be9b0371e788c$var$mediaRecorder.addEventListener('dataavailable', (event)=>{
        $b63be9b0371e788c$var$audioChunks.push(event.data);
    });
    $b63be9b0371e788c$var$mediaRecorder.addEventListener('stop', ()=>{
        if ($b63be9b0371e788c$var$audioChunks.length > 0) {
            const audioBlob = new Blob($b63be9b0371e788c$var$audioChunks, {
                type: 'audio/webm;codecs=opus'
            });
            $b63be9b0371e788c$var$sendAudioForTranscription(audioBlob);
        }
    });
    $b63be9b0371e788c$var$mediaRecorder.start();
    $b63be9b0371e788c$var$isRecording = true;
    $b63be9b0371e788c$var$startMicButton.classList.add('active-recording');
}
function $b63be9b0371e788c$var$stopCurrentRecording() {
    if ($b63be9b0371e788c$var$mediaRecorder && $b63be9b0371e788c$var$mediaRecorder.state === "recording") {
        $b63be9b0371e788c$var$mediaRecorder.stop();
        $b63be9b0371e788c$var$isRecording = false;
        $b63be9b0371e788c$var$isProcessing = true;
        $b63be9b0371e788c$var$speechStart = null;
        $b63be9b0371e788c$var$silenceStart = null;
        $b63be9b0371e788c$var$startMicButton.classList.remove('active-recording');
        $b63be9b0371e788c$var$startMicButton.classList.add('processing');
    }
}
function $b63be9b0371e788c$var$stopVADSession() {
    $b63be9b0371e788c$var$isSessionActive = false;
    $b63be9b0371e788c$var$isProcessing = false;
    if ($b63be9b0371e788c$var$isRecording) $b63be9b0371e788c$var$stopCurrentRecording();
    if (window.activeStream) {
        window.activeStream.getTracks().forEach((track)=>track.stop());
        window.activeStream = null;
    }
    if ($b63be9b0371e788c$var$audioContext) {
        $b63be9b0371e788c$var$audioContext.close();
        $b63be9b0371e788c$var$audioContext = null;
        $b63be9b0371e788c$var$analyser = null;
    }
    $b63be9b0371e788c$var$startMicButton.innerHTML = "\uD83C\uDFA4";
    $b63be9b0371e788c$var$startMicButton.classList.remove('recording');
    $b63be9b0371e788c$var$startMicButton.classList.remove('active-recording');
    $b63be9b0371e788c$var$startMicButton.classList.remove('processing');
}
function $b63be9b0371e788c$var$updateVADIndicator(db) {
    const normalizedLevel = Math.max(0, Math.min(1, (db - $b63be9b0371e788c$var$VAD_CONFIG.silenceThreshold) / ($b63be9b0371e788c$var$VAD_CONFIG.voiceThreshold - $b63be9b0371e788c$var$VAD_CONFIG.silenceThreshold)));
    if ($b63be9b0371e788c$var$isProcessing) $b63be9b0371e788c$var$startMicButton.style.borderColor = 'rgba(255, 165, 0, 0.8)';
    else if ($b63be9b0371e788c$var$isRecording) $b63be9b0371e788c$var$startMicButton.style.borderColor = `rgba(255, ${Math.floor(normalizedLevel * 255)}, 0, 0.8)`;
    else $b63be9b0371e788c$var$startMicButton.style.borderColor = `rgba(121, ${Math.floor(normalizedLevel * 255)}, 187, 0.8)`;
}
function $b63be9b0371e788c$var$sendAudioForTranscription(audioBlob) {
    const formData = new FormData();
    formData.append('audio', audioBlob, 'recording.webm');
    formData.append('languageCode', $b63be9b0371e788c$var$selectedLanguage);
    fetch('/.netlify/functions/transcribeAudio', {
        method: 'POST',
        body: formData
    }).then((response)=>response.json()).then((data)=>{
        if (data.transcript && data.transcript.trim()) {
            const message = data.transcript;
            $b63be9b0371e788c$var$updateTranscript('user', message);
            $b63be9b0371e788c$var$chatHistory.push({
                role: 'user',
                content: message
            });
            $b63be9b0371e788c$var$sendMessageToAnthropic(message);
        }
    }).catch((error)=>{
        console.error('Error sending audio for transcription:', error);
    }).finally(()=>{
        $b63be9b0371e788c$var$isProcessing = false;
        $b63be9b0371e788c$var$startMicButton.classList.remove('processing');
    });
}
function $b63be9b0371e788c$var$sendMessageToAnthropic(message) {
    console.log('Sending message:', message);
    $b63be9b0371e788c$var$stopOngoingAnimations();
    document.dispatchEvent(new CustomEvent('assistantThinking'));
    fetch('/.netlify/functions/anthropicProxy', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            messages: $b63be9b0371e788c$var$chatHistory,
            model: 'claude-haiku-4-5-20251001',
            max_tokens: 1024
        })
    }).then((response)=>response.json()).then((data)=>{
        if (data.content) {
            const message = data.content[0].text;
            $b63be9b0371e788c$var$updateTranscript('assistant', message);
            $b63be9b0371e788c$var$chatHistory.push({
                role: 'assistant',
                content: message
            });
            $b63be9b0371e788c$var$updateSuggestions();
        }
    }).catch((error)=>{
        console.error('Error:', error);
        $b63be9b0371e788c$var$updateTranscript('assistant', 'An error occurred while processing your message.');
    });
}
function $b63be9b0371e788c$var$handleSendMessage() {
    const message = $b63be9b0371e788c$var$chatInput.value.trim();
    if (message) {
        console.log('handleSendMessage - Processing message:', message);
        $b63be9b0371e788c$var$hideSuggestions();
        $b63be9b0371e788c$var$stopOngoingAnimations();
        $b63be9b0371e788c$var$updateTranscript('user', message);
        $b63be9b0371e788c$var$chatHistory.push({
            role: 'user',
            content: message
        });
        $b63be9b0371e788c$var$chatInput.value = '';
        $b63be9b0371e788c$var$sendMessageToAnthropic(message);
    }
}
function $b63be9b0371e788c$var$updateTranscript(role, text) {
    const transcriptContainer = document.getElementById('transcript');
    const newElement = document.createElement('div');
    newElement.className = `transcript-entry ${role}`;
    if (role === 'assistant') {
        transcriptContainer.appendChild(newElement);
        $b63be9b0371e788c$var$displayGradually(text, newElement);
    } else {
        // For user messages, just display immediately without animation
        newElement.innerHTML = text;
        transcriptContainer.appendChild(newElement);
        transcriptContainer.scrollTop = transcriptContainer.scrollHeight;
    }
    // Keep message limit
    const maxMessages = 20;
    const messages = transcriptContainer.querySelectorAll('.transcript-entry');
    if (messages.length > maxMessages) for(let i = 0; i < messages.length - maxMessages; i++)transcriptContainer.removeChild(messages[i]);
}
function $b63be9b0371e788c$var$displayGradually(text, element) {
    console.log('Starting new gradual display');
    const wordsPerMinute = 500;
    const words = text.split(' ');
    let currentIndex = 0;
    let displayedText = '';
    let timeoutId = null;
    // Generate a unique ID for this animation
    const animationId = Date.now();
    console.log('Animation ID:', animationId);
    // Cancel any existing display operation
    if ($b63be9b0371e788c$var$currentDisplayOperation) {
        clearTimeout($b63be9b0371e788c$var$currentDisplayOperation.timeoutId);
        $b63be9b0371e788c$var$currentDisplayOperation.element.innerHTML = $b63be9b0371e788c$var$currentDisplayOperation.displayedText;
        $b63be9b0371e788c$var$updateChatHistoryWithPartialMessage($b63be9b0371e788c$var$currentDisplayOperation.displayedText);
    }
    $b63be9b0371e788c$var$isAnimationActive = true;
    function displayNextWord() {
        console.log('Display next word, isAnimationActive:', $b63be9b0371e788c$var$isAnimationActive);
        // Check if this animation should still be running
        if (!$b63be9b0371e788c$var$isAnimationActive || $b63be9b0371e788c$var$currentDisplayOperation?.animationId !== animationId) {
            console.log('Animation stopped, keeping partial text');
            element.innerHTML = displayedText;
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
            $b63be9b0371e788c$var$updateChatHistoryWithPartialMessage(displayedText);
            return;
        }
        if (currentIndex < words.length) {
            displayedText = displayedText + words[currentIndex] + ' ';
            element.innerHTML = displayedText;
            if (currentIndex === 0) {
                const startEvent = new CustomEvent('textUpdate', {
                    detail: {
                        text: text,
                        sentenceEnded: false
                    }
                });
                document.dispatchEvent(startEvent);
            }
            currentIndex++;
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
            const delay = 60000 / wordsPerMinute;
            timeoutId = setTimeout(displayNextWord, delay);
            $b63be9b0371e788c$var$currentDisplayOperation = {
                timeoutId: timeoutId,
                displayedText: displayedText,
                element: element,
                animationId: animationId
            };
        } else {
            $b63be9b0371e788c$var$isAnimationActive = false;
            $b63be9b0371e788c$var$currentDisplayOperation = null;
            const stopEvent = new CustomEvent('textUpdate', {
                detail: {
                    text: displayedText,
                    sentenceEnded: true
                }
            });
            document.dispatchEvent(stopEvent);
            if ($b63be9b0371e788c$var$pendingSuggestions) {
                $b63be9b0371e788c$var$displaySuggestions($b63be9b0371e788c$var$pendingSuggestions);
                $b63be9b0371e788c$var$pendingSuggestions = null;
            }
        }
    }
    timeoutId = setTimeout(displayNextWord, 50);
    $b63be9b0371e788c$var$currentDisplayOperation = {
        timeoutId: timeoutId,
        displayedText: '',
        element: element,
        animationId: animationId
    };
}
function $b63be9b0371e788c$var$updateSuggestions() {
    fetch('/.netlify/functions/getSuggestions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            messages: $b63be9b0371e788c$var$chatHistory,
            language: $b63be9b0371e788c$var$selectedLanguage
        })
    }).then((response)=>response.json()).then((responseData)=>{
        console.log('Raw response from Anthropic:', responseData);
        try {
            $b63be9b0371e788c$var$pendingSuggestions = JSON.parse(responseData.content[0].text);
        // Don't display suggestions here anymore
        } catch (error) {
            console.error('Error parsing suggestions:', error);
        }
    }).catch((error)=>{
        console.error('Error getting suggestions:', error);
    });
}
function $b63be9b0371e788c$var$displaySuggestions(suggestions) {
    const container = document.getElementById('suggestion-container');
    container.innerHTML = '';
    const personalBubble = $b63be9b0371e788c$var$createSuggestionBubble(suggestions.personal);
    const foodBubble = $b63be9b0371e788c$var$createSuggestionBubble(suggestions.food);
    container.appendChild(personalBubble);
    container.appendChild(foodBubble);
}
function $b63be9b0371e788c$var$createSuggestionBubble(text) {
    const bubble = document.createElement('div');
    bubble.className = 'suggestion-bubble';
    bubble.textContent = text;
    bubble.addEventListener('click', ()=>{
        $b63be9b0371e788c$var$chatInput.value = text;
        $b63be9b0371e788c$var$handleSendMessageFromSuggestion(text);
        $b63be9b0371e788c$var$hideSuggestions();
    });
    return bubble;
}
function $b63be9b0371e788c$var$handleSendMessageFromSuggestion(text) {
    if (text) {
        console.log('handleSendMessageFromSuggestion:', text);
        // Don't trigger animation here anymore
        $b63be9b0371e788c$var$updateTranscript('user', text);
        $b63be9b0371e788c$var$chatHistory.push({
            role: 'user',
            content: text
        });
        $b63be9b0371e788c$var$chatInput.value = '';
        $b63be9b0371e788c$var$sendMessageToAnthropic(text);
    }
}
function $b63be9b0371e788c$var$hideSuggestions() {
    const container = document.getElementById('suggestion-container');
    container.innerHTML = '';
}
// Add this with your other event listeners
document.addEventListener('textUpdate', (event)=>{
    const { text: text, sentenceEnded: sentenceEnded } = event.detail;
    console.log('textUpdate event received:', {
        text: text,
        sentenceEnded: sentenceEnded
    });
    // Here you can trigger whatever animation you want based on the text and sentenceEnded flag
    sentenceEnded;
// Trigger character-by-character animation
});
function $b63be9b0371e788c$var$updateChatHistoryWithPartialMessage(partialText) {
    if ($b63be9b0371e788c$var$chatHistory.length > 0) {
        // Replace the last assistant message with the partial text
        const lastMessage = $b63be9b0371e788c$var$chatHistory[$b63be9b0371e788c$var$chatHistory.length - 1];
        if (lastMessage.role === 'assistant') lastMessage.content = partialText.trim();
    }
}
function $b63be9b0371e788c$var$stopOngoingAnimations() {
    console.log('Stopping animations...');
    // Force stop any ongoing animation
    $b63be9b0371e788c$var$isAnimationActive = false;
    if ($b63be9b0371e788c$var$currentDisplayOperation) {
        console.log('Current operation exists, clearing timeout:', $b63be9b0371e788c$var$currentDisplayOperation.timeoutId);
        // Clear the timeout immediately
        clearTimeout($b63be9b0371e788c$var$currentDisplayOperation.timeoutId);
        // Keep only the text that was displayed so far
        const partialText = $b63be9b0371e788c$var$currentDisplayOperation.displayedText;
        console.log('Partial text:', partialText);
        $b63be9b0371e788c$var$currentDisplayOperation.element.innerHTML = partialText;
        $b63be9b0371e788c$var$updateChatHistoryWithPartialMessage(partialText);
        // Immediately nullify the current operation
        $b63be9b0371e788c$var$currentDisplayOperation = null;
    } else console.log('No current operation to stop');
}


//# sourceMappingURL=repo.13924d6d.js.map
